import { GoogleOAuthProvider } from "@react-oauth/google";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { useTokenManager } from "@/hooks/useTokenManager";
import AnalyticsProvider from "./lib/analytics";
import { FeatureManagementProvider } from "./lib/feature-management/FeatureManagementProvider";
import UrqlProvider from "./lib/urqlProvider.tsx";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

const AuthTokenRefresh = () => {
  useTokenManager();
  return null;
};

const Providers = ({ children }: Props) => {
  return (
    <>
      <AuthTokenRefresh />
      <AnalyticsProvider>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
          <FeatureManagementProvider>
            <UrqlProvider>{children}</UrqlProvider>
          </FeatureManagementProvider>
        </GoogleOAuthProvider>
      </AnalyticsProvider>
    </>
  );
};

export default Providers;
